export function sanitizeKeyword(input, maxLen) {
  let s = String(input ?? '');

  // 角括弧<>を削除（HTML挿入の主なトリガーを除去）
  s = s.replace(/[<>]/g, '');

  // ASCII制御文字 (0x00-0x1Fと0x7F) を削除
  // eslint-disable-next-line no-control-regex -- ASCII制御文字(0x00-0x1F,0x7F)除去のため意図的に使用
  s = s.replace(/[\x00-\x1F\x7F]/g, '');

  const limit = Number(maxLen) || 0;
  if (limit > 0 && s.length > limit) {
    s = s.slice(0, limit);
  }
  return s;
}